export interface IProductData {
  Id: any;
  Ean: any;
  DisplayName: any;
  Brand: any;
  Categories: any[];
  Price: number;
  PriceExVat: number;
  CampaignCode: string;
  AbsoluteProductUrl: string;
  RelativeProductUrl: string;
  ProductImageUrl: string;
}

export module MedsEventData {
  export function Product<T extends IProductData>(id: string): T | undefined {
    window.EasyfyEventLayer = window.EasyfyEventLayer || {};
    let result: T = null;
    if (window.EasyfyEventLayer.products) {
      result = window.EasyfyEventLayer.products[id] as T;
    }
    return result;
  }
}
